import { render } from "./TelehealthTextChat.vue?vue&type=template&id=7a158f42&scoped=true&ts=true"
import script from "./TelehealthTextChat.vue?vue&type=script&lang=ts"
export * from "./TelehealthTextChat.vue?vue&type=script&lang=ts"

import "./TelehealthTextChat.vue?vue&type=style&index=0&id=7a158f42&lang=scss&scoped=true"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a158f42"]])

export default __exports__